function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable=\"true\"], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
window.__triumphLastSelectEnter = window.__triumphLastSelectEnter || null;

class SectionId {
  static #separator = '__';

  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || event.target.closest('.facets__disclosure')) return;

  const details = event.target.closest?.('.details');
  if (!details) return;

  if (event.target.closest('.details__content')) return;

  const checkbox = details.querySelector('.details__checkbox');
  if (!checkbox) return;

  event.preventDefault();
  checkbox.checked = !checkbox.checked;
  checkbox.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Enter') return;
    if (!(event.target instanceof HTMLSelectElement)) return;

    const formId = event.target.getAttribute('form') || '';
    if (!formId.startsWith('product-form-')) return;

    window.__triumphLastSelectEnter = {
      formId,
      targetId: event.target.id || '',
      value: event.target.value || '',
      timestamp: Date.now(),
    };
  },
  true
);

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container, megaMenu = false, startFocus = false) {
  let elements = getFocusableElements(container);
  let first = elements[0];
  let last = elements[elements.length - 1];

  removeTrapFocus();

  if (megaMenu) {
    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() === 'ESCAPE') {
        megaMenu.escapeCloseAction();
        return;
      }
      if (event.code.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (document.activeElement == startFocus) {
        if (first) first.focus();
        return;
      }

      if (!container.contains(document.activeElement)) {
        removeTrapFocus();
        return;
      }

      if (document.activeElement === first && event.shiftKey) {
        removeTrapFocus();
        return;
      }

      if (document.activeElement === last && !event.shiftKey) {
        removeTrapFocus();
        return;
      }
    };

    document.addEventListener('keydown', trapFocusHandlers.keydown);
    return;
  }

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia(exceptElement = null, index) {

  const shouldSkip = (el) =>
    exceptElement && (el === exceptElement || exceptElement.contains(el));

  document.querySelectorAll('.js-youtube').forEach((video) => {
    if (shouldSkip(video)) return;
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  document.querySelectorAll('.js-vimeo').forEach((video) => {
    if (shouldSkip(video)) return;
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  document.querySelectorAll('video').forEach((video) => {
    if (shouldSkip(video)) return;
    video.pause();
  });

  document.querySelectorAll('product-model').forEach((model) => {
    if (shouldSkip(model)) return;
    model.modelViewerUI?.pause();
  });
}

function removeTrapFocus(elementToFocus = null, fallbackSelector = null, restoreFocus = true) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (!elementToFocus || !restoreFocus) return;

  const isFocusable = (el) => !!el && !!el.offsetParent;

  if (isFocusable(elementToFocus) || !fallbackSelector) {
    elementToFocus.focus();
    return;
  }

  const stableAncestor = elementToFocus.closest(fallbackSelector);

  if (stableAncestor) {
    if (!stableAncestor.hasAttribute('tabindex')) {
      stableAncestor.setAttribute('tabindex', '-1');
    }
    stableAncestor.focus();
  }

  requestAnimationFrame(() => {
    if (isFocusable(elementToFocus)) {
      elementToFocus.focus();
    }
  });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

const DEFAULT_CURRENCY_DECIMALS = 2;

const CURRENCY_DECIMALS = {
  BHD: 3, BIF: 0, BYR: 0, CLF: 4, CLP: 0, DJF: 0, GNF: 0, IQD: 3, ISK: 0, JOD: 3, JPY: 0, KMF: 0, KRW: 0, KWD: 3, LYD: 3, MRO: 5, OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, UYW: 4, VND: 0, VUV: 0, XAF: 0, XAG: 0, XAU: 0, XBA: 0, XBB: 0, XBC: 0, XBD: 0, XDR: 0, XOF: 0, XPD: 0, XPF: 0, XPT: 0, XSU: 0, XTS: 0, XUA: 0,
};

function formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision) {
  const roundedNumber = (moneyValue / 100).toFixed(precision);
  let [a, b] = roundedNumber.split('.');
  if (!a) a = '0';
  if (!b) b = '';
  a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, (digit) => digit + thousandsSeparator);
  return precision <= 0 ? a : a + decimalSeparator + b.padEnd(precision, '0');
}

function formatMoneyShopify(moneyValue, template = '{{ amount }}', currency = 'USD') {
  return template.replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
    if (typeof placeholder !== 'string') return '';
    if (placeholder === 'currency') return currency;

    let thousandsSeparator = ',';
    let decimalSeparator = '.';
    let precision = CURRENCY_DECIMALS[currency.toUpperCase()] ?? DEFAULT_CURRENCY_DECIMALS;

    if (placeholder === 'amount') {
    } else if (placeholder === 'amount_no_decimals') {
      precision = 0;
    } else if (placeholder === 'amount_with_comma_separator') {
      thousandsSeparator = '.';
      decimalSeparator = ',';
    } else if (placeholder === 'amount_no_decimals_with_comma_separator') {
      thousandsSeparator = '.';
      precision = 0;
    } else if (placeholder === 'amount_no_decimals_with_space_separator') {
      thousandsSeparator = ' ';
      precision = 0;
    } else if (placeholder === 'amount_with_space_separator') {
      thousandsSeparator = ' ';
      decimalSeparator = ',';
    } else if (placeholder === 'amount_with_period_and_space_separator') {
      thousandsSeparator = ' ';
      decimalSeparator = '.';
    } else if (placeholder === 'amount_with_apostrophe_separator') {
      thousandsSeparator = "'";
      decimalSeparator = '.';
    }

    return formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision);
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    this.quantityUpdateUnsubscriber?.();
  }

  onInputChange() {
    this.validateQtyRules();
    this.updateTotals();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const isPlus = event.target.name === 'plus';

    if (isPlus) {
      parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0
        ? this.input.value = this.input.dataset.min
        : this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      this.updateTotals();
    }

    if (this.input.dataset.min === previousValue && !isPlus) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    const min = parseInt(this.input.min);
    const max = parseInt(this.input.max);

    if (min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus?.classList.toggle('disabled', value <= min);
    }

    if (max) {
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus?.classList.toggle('disabled', value >= max);
    }
  }

  updateTotals() {
    const qty = parseInt(this.input.value) || 0;
    const productForm = this.closest('.product-form');
    if (!productForm) return;
    productForm.querySelectorAll('.product-form__button-price').forEach(el => {
      const itemPrice = parseInt(el.dataset.itemPrice || '0');
      const total = itemPrice * qty;
      el.innerHTML = formatMoneyShopify(total, el.dataset.moneyFormat, el.dataset.currency);
    });
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._openedModal = null;
  }

  connectedCallback() {
    this.button =
      this.querySelector('button') ||
      this.querySelector('.popup-modal__link');

    if (!this.button) return;

    this.button.addEventListener('click', this._onClick);

    if (this.hasAttribute('data-preload-src')) {
      this.addEventListener('mouseenter', this._onMouseEnter, { once: true });
    }
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this._onClick);
    this.removeEventListener('mouseenter', this._onMouseEnter);
  }

  get modal() {
    const selector = this.getAttribute('data-modal');
    return selector ? document.querySelector(selector) : null;
  }

  setDesignMode(isDesignMode) {
    this.modal.dataset.designMode = isDesignMode;
    this.modal.reinitialize();
  }

  open(button = this.button) {
    const modal = this.modal;
    if (!modal || modal.isOpen) return;

    this._openedModal = modal;
    modal.openedViaKeyboard = this._openedViaKeyboard ?? false;

    const show = () => {
      const maybePromise =
        typeof modal.preSyncForOpener === 'function' ? modal.preSyncForOpener(button) : null;

      if (maybePromise?.then) {
        maybePromise.then(() => modal.show(button));
      } else {
        modal.show(button);
      }

      this.dispatchEvent(
        new CustomEvent('modal:opened', {
          detail: { modal, button },
          bubbles: true
        })
      );
    };

    if (typeof modal.show === 'function') {
      show();
    } else {
      customElements.whenDefined(modal.localName).then(show);
    }
  }

  close({ force = false } = {}) {
    const modal = this._openedModal || this.modal;
    if (!modal || !modal.isOpen) return;

    const closeAction =
      force && typeof modal.forceClose === 'function' ? modal.forceClose() : modal.hide?.();

    Promise.resolve(closeAction).then(() => {
      this.dispatchEvent(
        new CustomEvent('modal:closed', {
          detail: { modal },
          bubbles: true
        })
      );
    });

    this._openedModal = null;
  }

  _onMouseEnter() {
    const src = this.dataset.preloadSrc;
    if (!src) return;

    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  }

  _onClick(e) {
    this._openedViaKeyboard = e.detail === 0;
    e.preventDefault();
    if (!!this.dataset.openedEditorPassword) {
      this.setDesignMode(true);
    }
    this.open();
  }
}

customElements.define('modal-opener', ModalOpener);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.preloadedImages = new Set();
    this.hoverTimer = null;
    this.onlyColors = this.hasAttribute('data-show-only-colors');
    this._hoverHandler = this.handleHoverPreload.bind(this);
    this.addEventListener('mouseover', this._hoverHandler);
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  disconnectedCallback() {
    this.removeEventListener('mouseover', this._hoverHandler);
  }

  handleHoverPreload(e) {
    if (window.matchMedia('(hover: none)').matches) return;

    const label = e.target.closest('label.swatch-input__label');
    if (!label) return;

    const input = this.querySelector(`#${CSS.escape(label.htmlFor)}`);
    const mediaSrc = input?.dataset.mediaSrc;

    if (!mediaSrc) return;

    clearTimeout(this.hoverTimer);
    this.hoverTimer = setTimeout(() => this.preloadImage(mediaSrc), 80);
  }

  preloadImage(src) {
    if (this.preloadedImages.has(src)) return;

    const img = new Image();
    img.src = src;

    this.preloadedImages.add(src);
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const plainSelectValue = target.closest('.select--plain')?.querySelector('[data-select-value]');
      if (plainSelectValue) plainSelectValue.textContent = target.selectedOptions[0].text.trim();

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  disconnectedCallback() {
    this.removeEventListener('mouseover', this._hoverHandler);
  }
}

customElements.define('variant-selects', VariantSelects);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

class ProductComplementary extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 600px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-complementary');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('.complementary-products__container') && this.classList.contains('complementary-products')) {
          (this.parentElement?.classList.contains('product__info-block') ? this.parentElement : this).remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-complementary--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-complementary', ProductComplementary);
